module.exports = __webpack_public_path__ + "static/media/image-card-1.57f81982.png";